import styled, { css } from 'styled-components';

import Socials from 'Modules/PromoPoint/Socials';
import { Icon, SocialWrapper } from 'Modules/PromoPoint/Socials/Socials.styled';

export const DefaultGroupWrapper = styled.div`
    ${({ theme }) => css`
        p,
        li {
            font-weight: 300;
            line-height: 1.65;
        }

        h2 {
            font-weight: bold;
            font-size: 1.5rem;

            @media ${theme.breakpoints.large.media} {
                font-size: 1.75rem;
            }
        }

        h3,
        h4,
        h5,
        h6 {
            font-weight: bold;
            font-size: 1.125rem;

            @media ${theme.breakpoints.large.media} {
                font-size: 1.25rem;
            }
        }
    `}
`;

export const WeekWrapper = styled.div`
    margin-right: 1rem;
    height: 5.5rem;
    width: 5rem;

    svg {
        min-width: 5rem;
    }
`;

export const Promopoint = styled(Socials)`
    ${({ theme }) => css`
        padding: 1rem 1rem 1.5rem;

        ${SocialWrapper} {
            margin-top: 1rem;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 1.6875rem;

            ${Icon} {
                margin-top: 0.5rem;
            }
        }
    `}
`;

export const PromoPointWrapper = styled.div`
    ${({ theme }) => css`
        @media ${theme.breakpoints.large.media} {
            padding-top: 3rem;
        }
    `}
`;
